import React from "react";
import { validateEmail } from "./entities";

export const parseEmails = (emailString: string): string[] => {
  return emailString
    .split(/[\s,]+/)
    .map((email) => email.trim())
    .filter((email) => email.length > 0);
};

export const validateEmails = (emails: string[]) => {
  return emails.filter((email) => validateEmail(email));
};

interface EmailValidationProps {
  error?: string | null;
  invalidEmails?: string[];
  duplicateEmails?: string[];
}

export const EmailValidation: React.FC<EmailValidationProps> = ({
  error,
  invalidEmails = [],
  duplicateEmails = [],
}) => (
  <>
    {error && <p className="text-error mt-1">{error}</p>}

    {invalidEmails.length > 0 && (
      <p className="text-error mt-1">
        Invalid email {invalidEmails.length > 1 ? "s" : ""}:{" "}
        {invalidEmails.join(", ")}
      </p>
    )}

    {duplicateEmails.length > 0 && (
      <p className="text-error mt-1">
        {duplicateEmails.length > 1 ? "These emails are" : "This email is"}{" "}
        already added: {duplicateEmails.join(", ")}
      </p>
    )}
  </>
);
